import { Injectable } from '@angular/core';

import { logger } from '@assess/shared/logger';

import { NewRelicConfig } from './new-relic.config';

@Injectable({ providedIn: 'root' })
export class NewRelicService {
  private readonly instanceLogger = logger.child({ context: NewRelicService.name });

  private get newrelic(): typeof newrelic | undefined {
    if (!this.config.enabled) {
      return undefined;
    }

    const retval = window?.newrelic ?? undefined;

    if (!retval) {
      this.instanceLogger.warn('New Relic instance is nil');
    }

    return retval;
  }

  constructor(private readonly config: NewRelicConfig) {}

  addRelease(name: string, value: string) {
    this.newrelic?.addRelease(name, value);
  }

  noticeError(error: Error | string, customAttributes?: Record<string, newrelic.SimpleType>) {
    this.newrelic?.noticeError(error, customAttributes);
  }

  setCustomAttribute(name: string, value: newrelic.SimpleType) {
    this.newrelic?.setCustomAttribute(name, value);
  }
}
